import { Stack } from '@mui/system';
import { ReactNode } from 'react';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';

const CompanyTradeDataWhiteBox = ({ children }: { children: ReactNode }) => {
  return (
    <WhiteBoxContent>
      <Stack spacing={3}>{children}</Stack>
    </WhiteBoxContent>
  );
};

export default CompanyTradeDataWhiteBox;
